import { SxProps, Theme } from '@mui/material/styles'

interface StackStyleProps {
  flex?: string | number
  wrap?: string
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  items?: string
  justify?: string
  spacing?: number
}

export const getStackStyles = (props: StackStyleProps): SxProps<Theme> => ({
  display: 'flex',
  flex: props.flex,
  flexWrap: props.wrap,
  flexDirection: props.direction,
  alignItems: props.items,
  justifyContent: props.justify,
  '& > *:not(:last-child)': {
    marginBottom:
      props.direction === 'column' || props.direction === 'column-reverse'
        ? props.spacing
        : undefined,
    marginRight:
      props.direction === 'row' || props.direction === 'row-reverse'
        ? props.spacing
        : undefined,
  },
})
